import React, { useState } from 'react';
import { View, Text, StyleSheet, Image, Alert, Platform } from 'react-native';
import Amplify, { Auth } from 'aws-amplify';
import { SafeAreaView } from 'react-native-safe-area-context';
import LoginButtonInput from '../components/LoginButtonInput';
import LoginButton from '../components/LoginButton';
import SignUpButton from '../components/SignUpButton';
import CreateAccountButton from '../components/CreateAccountButton';
import mainIcon from '../assets/uploadifierSymbol.png'

export default function ConfirmCreateAccount({ navigation }) {
  const [username, setUsername] = useState('');
  const [authCode, setAuthCode] = useState('');
  
  async function confirmSignUp() {
    try {
      await Auth.confirmSignUp(username, authCode);
      //await Auth.confirmCreateAccount(username, authCode);
      console.log(' Code confirmed');
      //navigation.navigate('Home');
      //navigation.navigate('Nested Navigator 2', { screen: 'screen D' });
      //navigation.navigate('AppStack', { screen: 'Home' });
      navigation.navigate("Login")
    } catch (error) {en
      if (Platform.OS === 'android' || Platform.OS === 'ios'){
        Alert.alert(' Verification code does not match. Please enter a valid verification code.', error.code);
        //navigation.navigate('Home');
      }
      if (Platform.OS === 'web'){
        alert(' Verification code does not match. Please enter a valid verification code.', error.code);
        //navigation.navigate('Home');
      }
      console.log(
        ' Verification code does not match. Please enter a valid verification code.',
        error.code
      );
    }
    
  }

 // need to add resend conf code to this screen 
 // <SignUpButton
 // title="Resend Confirmation code" 
 // onPress={resendConf} 
///>

 //<Text style={styles.title}>Once you confirm your password, press the return button below </Text>

 //<LoginButton 
 //title="Take me back to Login" 
 //onPress={() => navigation.navigate("Login")}
///>

//<LoginButton 
// title="Take me home" 
// onPress={() => navigation.navigate('CreateAccount', { screen: 'Login', params : {}})}
///>

  async function resendConf() {
    await Auth.resendSignUp(email);
    //await Auth.signUp({ username, password, attributes: { email, phone_number } });
      console.log(' resent conf code for '+ username);
      navigation.navigate('ConfirmCreateAccount');
  }  
  return (
    <SafeAreaView style={styles.safeAreaContainer}>
      <View style={styles.container}>
        <Text style={styles.title}>Confirm Sign Up</Text>
        <LoginButtonInput
          value={username}
          onChangeText={text => setUsername(text)}
          leftIcon="account"
          placeholder="Enter Email Address"
          autoCapitalize="none"
          keyboardType="email-address"
          textContentType="emailAddress"
        />
        <LoginButtonInput
          value={authCode}
          onChangeText={text => setAuthCode(text)}
          leftIcon="numeric"
          placeholder="Enter verification code"
          keyboardType="numeric"
        />
        <LoginButton title="Confirm Sign Up" onPress={confirmSignUp} />

       


        <Image source={mainIcon} style={{ width: 512, height: 512 }} />
      </View>
    </SafeAreaView>
  );
}


const styles = StyleSheet.create({
      safeAreaContainer: {
        flex: 1,
        backgroundColor: 'white'
      },
      container: {
        flex: 1,
        alignItems: 'center'
      },
      title: {
        fontSize: 20,
        color: '#202020',
        fontWeight: '500',
        marginVertical: 15
      }
    });